import React, { Component, useMemo } from 'react';
import Collapsible from 'react-collapsible';
import { FaPause, FaSortDown, FaSortUp, FaTachometerAlt } from 'react-icons/fa';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { connect } from 'react-redux';
import api from '../../axios-local-api';
import DeviceIcon from '../../components/UI/DeviceIcon/DeviceIcon';
import Error from '../../components/UI/Error/Error';
import Modal from '../../components/UI/Modal/Modal';
import SlidePanel from '../../components/UI/SlidePanel/SlidePanel';
import Spinner from '../../components/UI/Spinner/Spinner';
import Success from '../../components/UI/Success/Success';
import Box from '../../hoc/Box/Box';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import { sortDataByProperty } from '../../shared/utility';
import * as actions from '../../store/actions/index';
import DeviceDetails from './DeviceDetails/DeviceDetails';
import classes from './DeviceList.css';
import {
  getDeviceName,
  getDeviceModel,
  getDeviceIconUrl,
  getSoftwareVersion,
  getDeviceSignalStatus,
  getDevicePauseStatus,
  getGroupMap,
  getGroupName
} from '../../shared/common';
import SelectDropdown from '../../shared/SelectDropdown/SelectDropdown';

const connectionStatusFilters = [ { "value": "ALL", "label": "ALL" }, { "value": "2.4G", "label": "2.4 GHz" }, { "value": "5G", "label": "5 GHz" }, 
  { "value": "6G", "label": "6 GHz" }, { "value": "Ethernet", "label": "Ethernet" }, { "value": "N/A", "label": "N/A" }]

  export class DeviceList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adding: false,
      showDeets: null,
      deviceIconUrl: null,
      upArrows: true,
      devices: this.props.passedDevices,
      deviceReset: false,
      advancedDeviceSpinner: [],
      deviceModel: null,
      softwareVersion: null,
      success: false,
      error: false,
      status: '',
      currentPage: 1,
      loadedAdvancedDeviceIds: false,
      itemsPerPage: 12,
      currentRecords: null,
      sortBy: '',
      sortDirection: 'asc',
      speedBoostDevices: {},
      updatedCustomSchedule: false,
      deletedDeviceMac: null,
      showDeviceDetailsPanel: false,
      filterOptions: ''
    };
    this.resetUpArrows = this.resetUpArrows.bind(this);
    this.updateScheduleDetails = this.updateScheduleDetails.bind(this);
    this.updateDeletedDevice = this.updateDeletedDevice.bind(this);
  }

  componentDidMount() {
    // console.log('test :::: 68', this.state.filterOptions)
    this.setState(
      {
        currentRecords: this.buildDevicDetailsData(
          this.props.devicesByEquipment,
          this.props
        ),
      },
      () => {
        // this.sortTable('deviceSignalStatus');
      }
    );
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.loading !== nextProps.loading) {
      this.setState({ upArrows: true, currentRecords: null });
    }
    this.setState({
      filterOptions: ''
    })
    let sortTable = false;

    if (
      (!this.state.currentRecords && nextProps.devicesByEquipment && nextProps.devicesByEquipment.length) ||
      (!this.state.currentRecords?.map(({ deviceSignalStatus }) => deviceSignalStatus) !== nextProps.devicesByEquipment?.map(({ status }) => status)) ||
      (this.props.selectedEquipment && nextProps.selectedEquipment && this.props.selectedEquipment.serialNumber !== nextProps.selectedEquipment.serialNumber) ||
      (this.props.selectedEquipment.type !== nextProps.selectedEquipment.type) ||
      (nextProps.advancedDeviceIds && this.props.advancedDeviceIds && (Object.keys(nextProps.advancedDeviceIds).length !== Object.keys(this.props.advancedDeviceIds).length))

    ) {
      sortTable = true;
      this.setState(
        {
          currentRecords: this.buildDevicDetailsData(
            nextProps.devicesByEquipment,
            nextProps
          ),
        });
    }

    if (
      Object.keys(nextProps.speedBoostDevices).length !==
      Object.keys(this.state.speedBoostDevices).length
    ) {
      sortTable = true;
      this.setState(
        {
          currentRecords: this.buildDevicDetailsData(
            nextProps.devicesByEquipment,
            nextProps
          ),
          speedBoostDevices: nextProps.speedBoostDevices,
        }
      );
    }

    // if(sortTable){
    //   this.sortTable(this.state.sortBy);
    // }
  }
  sortRecordsOnSignalStatus = (sortedRecords) => {
    if (!sortedRecords) return null;
    const signalsortOrder = ['Excellent',
      'Good',
      'Fair',
      'Poor',
      'Paused',
      'Calculating',
      'Disconnected' ];
    let otherStatusesDevices = [];
    signalsortOrder.map((status) => {
      sortedRecords.find((element) => {
        let {deviceSignalStatus} = getDeviceSignalStatus(element);
        if (deviceSignalStatus === status){
          otherStatusesDevices.push(element);
        }
      })
    });
    return otherStatusesDevices;
  }

  buildDevicDetailsData = (newCurrentRecords = [], nextProps) => {
    //  console.log('test :::: 142')
    if (!newCurrentRecords) return null;
    let currentSortedRecords = newCurrentRecords;
    // if(this.state.showDeviceDetailsPanel && !!this.state.currentRecords){
    //   currentSortedRecords= this.state.currentRecords;
    // }

    let deviceGroups = getGroupMap(this.props.deviceGroups);
    const boostedDevices =
      nextProps.speedBoostDevices &&
        Object.keys(nextProps.speedBoostDevices).length
        ? nextProps.speedBoostDevices.devices
        : [];
    const sortedRecords = this.state.sortBy === '' ?
     this.sortRecordsOnSignalStatus(currentSortedRecords) :
     sortDataByProperty(
      currentSortedRecords,
      this.state.sortBy,
      this.state.sortDirection
     );
    return sortedRecords?.map((element) => {
     let {deviceName} = getDeviceName(element, this.props.advancedDeviceIds);
     element.deviceName = deviceName;

      element.paused = getDevicePauseStatus(element);

      let {deviceSignalStatus, freq, status} = getDeviceSignalStatus(element);
      element.freq = freq;
      element.status = status;
      element.deviceSignalStatus = deviceSignalStatus;

      let deviceGroupName = getGroupName(deviceGroups, element.mac);
      if (deviceGroupName && deviceGroupName.length > 12) {
        deviceGroupName = deviceGroupName.substring(0, 12) + '...';
      }
      if (!deviceGroupName) {
        deviceGroupName = 'Ungrouped';
      }
      element.deviceGroupName = deviceGroupName;

      element.deviceConnectedTo = this.getConnectedTo(element);
      element.deviceModel = getDeviceModel(element.mac, 'shortName', this.props.advancedDeviceIds);
      const findBoostDevice = boostedDevices.filter(ele => { 
          const macFilter = element.mac.replaceAll(':', '');
          return ele.clientMac === macFilter;
        }); 
      element.boost = findBoostDevice ? findBoostDevice.status : 'N/A';
      element.boostFailureReason = findBoostDevice && findBoostDevice.boostFailureReason ? findBoostDevice.boostFailureReason : 'N/A';
      element.outOfHome =
        findBoostDevice && findBoostDevice?.outOfHome
          ? findBoostDevice?.outOfHome
          : false;
      return element;
    });
  };
  componentDidUpdate() {
    if (!this.state.loadedAdvancedDeviceIds) {
      if (this.props.devicesByEquipment) {
        let deviceMacs = this.props.devicesByEquipment.map((d) => d.mac);
        if (deviceMacs.length > 0) {
          this.setState({
            loadedAdvancedDeviceIds: true,
          });
          this.props.onGetAdvancedDeviceIds(deviceMacs);
        }
      }
    }
//  console.log('test :::: 207', this.props.devicesByEquipment,this.state.currentRecords, this.state.filterOptions)
     if (
      this.props.devicesByEquipment &&
      this.state.currentRecords &&
      this.props.devicesByEquipment.length !== this.state.currentRecords.length
      && this.state.filterOptions === ''
    ) {
      // console.log('test :::: 213')
      this.setState(
        {
          currentRecords: this.buildDevicDetailsData(
            this.props.devicesByEquipment,
            this.props
          ),
        });

        this.sortTable(this.state.sortBy);
    }

    if (this.props.devicesByEquipment && this.state.showDeets && this.state.showDeets.mac) {
      let deviceMacs = this.props.devicesByEquipment.map((d) => d.mac);
      if(this.state.deletedDeviceMac !== null && !deviceMacs.includes(this.state.deletedDeviceMac)){
        this.setState({
          showDeets: null,
          adding: false
        })
      }else{
        this.props.devicesByEquipment.map((d) => {
          if (d.mac === this.state.showDeets.mac) {
            if (d.freeze.frozen !== this.state.showDeets.freeze.frozen
              || d.name !== this.state.showDeets.name
              || d.freeze.timeTemplates.length !== this.state.showDeets.freeze.timeTemplates.length
              || this.state.updatedCustomSchedule && this.props.success ||
              (this.state.showDeets.steering !== d.steering)
            ) {
              this.setState({
                showDeets: d,
                updatedCustomSchedule: false
              })
              this.getAdvancedDeviceHandler(d);
            }
          }
        });
      }

    }
  }

  updateScheduleDetails() {
    this.setState({
      updatedCustomSchedule: true
    })
  }

  loadAdvancedDeviceIds = () => {
    if (this.props.devicesByEquipment) {
      let deviceMacs = this.props.devicesByEquipment.map((d) => d.mac);
      if (deviceMacs.length > 0) {
        this.props.onGetAdvancedDeviceIds(deviceMacs);
      }
    }
  };

  getAdvancedDeviceHandler(element) {
    this.props.onGetAdvancedDevice(element.mac, 1);
  }

  openHandler() {
    this.setState({
      upArrows: true,
    });
  }
  closeHandler() {
    this.setState({
      upArrows: false,
    });
  }
  resetUpArrows() {
    this.setState({
      upArrows: false,
    });
  }
  handleClick = (event) => {
    this.setState({
      itemsPerPage: this.state.itemsPerPage + 12,
    });
  };

  showDeviceDetails = (element, deviceIconUrl) => {
    let status;
    if (
      element.connectionState &&
      element.connectionState === 'connected' &&
      element.freeze.frozen === true
    ) {
      status = 'Paused';
    } else if (element.health && element.health.status) {
      status =
        element.health.status.charAt(0).toUpperCase() +
        element.health.status.slice(1);
    } else {
      status = 'Disconnected';
    }
    let deviceModel = getDeviceModel(element.mac, 'fullName', this.props.advancedDeviceIds);
    let softwareVersion = getSoftwareVersion(element.mac, this.props.advancedDeviceIds);

    this.getAdvancedDeviceHandler(element);
    setTimeout(() => {
      this.setState({
        showDeviceDetailsPanel: true,
        showDeets: element,
        status: status,
        adding: true,
        deviceIconUrl: deviceIconUrl,
        deviceModel: deviceModel,
        softwareVersion: softwareVersion,
        deletedDeviceMac: null
      });
    }, 1000)

  };

  modalCancelHandler = () => {
    this.setState({
      adding: false,
      showDeviceDetailsPanel: false
    });
  };
  successErrorResetHandler = () => {
    this.setState({ error: false, success: false });
    if (this.props.deviceSteeringSuccess || this.props.deviceSteeringFailed) {
      this.props.onResetDevicesSteeringErrorSuccess();
    } else {
      this.props.onResetDevicesErrorSuccess();
    }
    this.resetUpArrows();
    this.props.onSetSelectedEquipment(this.props.selectedEquipment);
  };
  resetDeviceHandler = () => {
    this.setState({ deviceReset: true });
    setTimeout(() => {
      this.setState({ deviceReset: false });
    }, 1);
  };

  getConnectedTo = (device) => {
    if (!device) {
      return 'N/A';
    }
    if (device.connectionState === 'disconnected') {
      return 'N/A';
    }
    if (!this.props.realWan) {
      return 'N/A';
    }
    if(device.networkId === "ABWAdditionalNetwork" && device.vapType === "fronthaul"){
      return this.props.secondSsid?.secondSsidNetwork?.ssid
    }
    let router = {
      id: this.props.realWan.id,
      mac: this.props.realWan.mac,
      //Wanted to display name as Router in the connectedTo column if the parent is Router
      nickname: 'Router',
    };
    let claimedPodMap = {};

    if (this.props.claimedPods && this.props.claimedPods.length) {
      claimedPodMap = this.props.claimedPods.reduce((acc, cpod) => {
        acc[cpod.id] = cpod;
        return acc;
      }, {});
    }
    claimedPodMap[router.id] = router;
    let parent;
    if (!device.leafToRoot) {
      parent = router;
    } else {
      parent = claimedPodMap[device.leafToRoot[0].id];
    }
    if (!parent) {
      return 'N/A';
    }
    let connectedTo = parent.nickname || parent.defaultName;

    if (connectedTo && connectedTo.length > 12) {
      connectedTo = connectedTo.substring(0, 12) + '...';
    }
    return connectedTo;
  };

  sortTable(columnName, calledFrom='column') {
    if (!this.state.currentRecords) return;
    const { sortDirection, currentRecords } = this.state;
    let deviceGroups = getGroupMap(this.props.deviceGroups);

    currentRecords.forEach((element) => {
      let deviceGroupName = getGroupName(deviceGroups, element.mac);
      if (deviceGroupName && deviceGroupName.length > 12) {
        deviceGroupName = deviceGroupName.substring(0, 12) + '...';
      }
      if (!deviceGroupName) {
        deviceGroupName = 'Ungrouped';
      }
      element.deviceGroupName = deviceGroupName;
    })
    const records = sortDataByProperty(
      currentRecords,
      columnName,
      calledFrom === 'column' ? (sortDirection === 'desc' ? 'asc' : 'desc') : sortDirection
    );
    this.setState({
      currentRecords: records,
      sortDirection: calledFrom === 'column' ? (sortDirection === 'desc' ? 'asc' : 'desc') : sortDirection,
      sortBy: columnName,
    });
    return;
  }
  filterDeviceData = (event, name) => {
    const { value } = event;
    this.setState({
      filterOptions: {
        [name]: value
      }
    });
    let filterDeviceData;
    if(value == 'ALL'){
      // console.log('all ::', this.props.devicesByEquipment)
      filterDeviceData = this.props.devicesByEquipment;
    }else {
      if(value == 'N/A'){
        filterDeviceData = this.props.devicesByEquipment.filter(e => e.connectionState === 'disconnected')
      }else{
        if(value === 'Ethernet'){
          filterDeviceData = this.props.devicesByEquipment.filter(e => e?.medium === 'ethernet')
        }else{
          filterDeviceData = this.props.devicesByEquipment.filter(e => e?.freqBand?.includes(value))
        }
      }
    }
    this.setState({
      currentRecords: filterDeviceData
    })
  }

   getGroupNameOfDevice = (deviceGroupName) => {
    return (
      <td
        style={{
          padding: '12px',
          borderRight: 'none',
          borderLeft: 'none',
          borderBottom: '1px solid lightgray',
        }}
      >
        {' '}
        <span
          className={classes.showDesktop}
          style={{
            overflowWrap: 'break-word',
            width: '100px',
            whiteSpace: 'pre',
          }}
        >
          {deviceGroupName}
        </span>
        <span
          className={classes.showMobile}
          style={{ whiteSpace: 'pre' }}
        >
          {' '}
          {deviceGroupName}
        </span>
      </td>
    );
  }
  getBoostElementStatus = (boostStatus) => {
    let boostElement;
    const  boostedElementHtml = (status)=>
      (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <FaTachometerAlt color="#0073D1" height="24px" />
          <span>{status}</span>
        </div>
      );


    const  notBoostedElementHtml = (status)=>
      (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <FaTachometerAlt color="rgb(204, 145, 30)" height="24px" />
          <span style={{ whiteSpace: 'nowrap' }}>{status}</span>
        </div>
      );


    switch (boostStatus) {
      case 'CAPABLE':
        boostElement = boostedElementHtml('CAPABLE');
        break;
      case 'NOT_CAPABLE':
        boostElement = notBoostedElementHtml('NOT CAPABLE');
        break;
      case 'BOOSTED':
        boostElement = boostedElementHtml('BOOSTED');
        break;
      case 'NOT_BOOSTED':
        boostElement = notBoostedElementHtml('NOT BOOSTED');
        break;
      default:
        boostElement = <span> N/A </span>;
    }

    return boostElement;
  }

  prepareDataForTable = (currentRecords, deviceGroups, featureFlags) => {
    // console.log('currentRecords :::', currentRecords)

      if(currentRecords.length > 0){
        const colorCode = {
          connected: 'green',
          excellent: 'green',
          disconnected: 'red',
          poor: 'red',
          good: 'green',
          fair: 'red',
          calculating: 'orange',
        };
        return currentRecords.map((element, ind) => {
          let colorDot, paused;
          let freq;
          let status;
          const boostedDevices =
            this.props.speedBoostDevices &&
              Object.keys(this.props.speedBoostDevices).length
              ? this.props.speedBoostDevices.devices
              : [];
          const findBoostData = boostedDevices.filter(ele => { 
            const macFilter = element.mac.replaceAll(':', '');
            return ele.clientMac === macFilter;
          }); 
          const boostStatus = findBoostData ? findBoostData[0]?.boostStatus : 'Disconnected';
          let boostElement = this.getBoostElementStatus(boostStatus);

          if (element.freeze.frozen === true) {
            paused = <FaPause color={'gray'} />;
          } else {
            paused = '';
          }
          if (element.health && element.health.status) {
            status =
              element.health.status.charAt(0).toUpperCase() +
              element.health.status.slice(1);
          } else {
            status = 'Disconnected';
          }
          if (element.connectionState === 'disconnected') {
            freq = 'N/A';
          } else if (element.medium && element.medium === 'wifi') {
            if (
              element.freqBand &&
              (element.freqBand.includes('6G') ||
                element.freqBand.includes('6g'))
            ) {
              freq = '6GHz';
            } else if (
              element.freqBand &&
              (element.freqBand.includes('5G') ||
                element.freqBand.includes('5g'))
            ) {
              freq = '5GHz';
            } else if (
              element.freqBand &&
              (element.freqBand.includes('2.4G') ||
                element.freqBand.includes('2.4g'))
            ) {
              freq = '2.4GHz';
            } else {
              freq = 'N/A';
            }
          } else if (element.medium && element.medium === 'ethernet') {
            freq = 'Ethernet';
          } else {
            freq = 'N/A';
          }
          if (element.deviceSignalStatus === 'Calculating') {
            colorDot = (
              <div
                className={classes.colorDot}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <div className={classes.Calculating}></div>
                <div style={{ width: '10px' }} />
                <div style={{ color: colorCode.calculating }}>{status}</div>
              </div>
            );
          } else if (
            element.connectionState &&
            element.connectionState === 'connected' &&
            element.freeze.frozen === true
          ) {
            status = 'Paused';
            colorDot = (
              <div
                className={classes.colorDot}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <div className={classes.Paused}></div>
                <div style={{ width: '10px' }} />
                <div>Paused</div>
              </div>
            );
          } else if (
            element.connectionState &&
            element.connectionState === 'connected' &&
            element.capabilities
          ) {
            colorDot = (
              <div
                className={classes.colorDot}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <div
                  className={
                    status === 'Poor' || status === 'Fair' ? classes.NotConnected : classes.Connected
                  }
                ></div>
                <div style={{ width: '10px' }} />
                <div
                  style={{
                    color:
                      status === 'Poor' || status === 'Fair' ? colorCode.poor : colorCode.connected,
                  }}
                >
                  {status}
                </div>
              </div>
            );
          } else if (
            element.connectionState &&
            element.connectionState === 'connected' &&
            !element.capabilities
          ) {
            colorDot = (
              <div
                className={classes.colorDot}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <div className={classes.NotConnected}></div>
                <div style={{ width: '10px' }} />
                <div styles={{ color: colorCode.disconnected }}>{status}</div>
              </div>
            );
          } else {
            colorDot = (
              <div
                className={classes.colorDot}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <div className={classes.NotConnected}></div>
                <div style={{ width: '10px' }} />
                <div style={{ color: colorCode.poor }}>Disconnected</div>
              </div>
            );
          }
          var frequencyValue = element.freqBand;
          if (frequencyValue !== undefined) {
            frequencyValue = frequencyValue.replace('2G', '2.4G');
            frequencyValue = frequencyValue.replace('G', 'GHz');
          }
         let {shortDeviceName} = getDeviceName(element, this.props.advancedDeviceIds);

         let deviceGroupName = getGroupName(deviceGroups, element.mac);


          if (deviceGroupName && deviceGroupName.length > 12) {
            deviceGroupName = deviceGroupName.substring(0, 12) + '...';
          }
          if (!deviceGroupName) {
            deviceGroupName = 'Ungrouped';
          }

          let deviceIconUrl = getDeviceIconUrl(element.mac, this.props.advancedDeviceIds);
          let GroupName = !this.props.enableGroupPause ? '' : this.getGroupNameOfDevice(deviceGroupName);
          let speedBoostName = null;
          if (
            featureFlags.includes('speedBoost') &&
            this.props.speedBoostDevices &&
            this.props.speedBoostDevices.eligible &&
            !this.props.hideSpeedBoostColumn
          ) {
            speedBoostName = (
              <td
                id="Boost"
                style={{
                  padding: '12px',
                  textAlign: 'center',
                  borderRight: 'none',
                  borderLeft: 'none',
                  borderBottom: '1px solid lightgray',
                }}
              >
                {boostElement}
              </td>
            );
          }

          return (
            <Box key={ind}>
              <tr>
                <td
                  style={{
                    padding: '20px',
                    borderRight: 'none',
                    borderLeft: 'none',
                    borderBottom: '1px solid lightgray',
                  }}
                  className={[classes.showDesktop, classes.showDesktop1].join(
                    ' '
                  )}
                >
                  <DeviceIcon size={30} iconUrl={deviceIconUrl} />
                  <span
                    id="deviceName"
                    style={{
                      padding: '6px 6px 6px 7px',
                      cursor: 'pointer',
                      lineHeight: '1.5em',
                      height: '2em',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                    }}
                    className={[classes.devName, classes.RegularButton].join(
                      ' '
                    )}
                    onClick={() =>
                      this.showDeviceDetails(
                        element,
                        deviceIconUrl
                      )
                    }
                  >
                    {shortDeviceName}
                  </span>
                </td>

                <td id = 'Signal'
                  style={{
                    padding: '12px',
                    borderRight: 'none',
                    borderLeft: 'none',
                    borderBottom: '1px solid lightgray',
                  }}
                >
                  {colorDot}
                </td>
                <td
                  style={{
                    padding: '12px',
                    borderRight: 'none',
                    borderLeft: 'none',
                    borderTop: '0pxy',
                    borderBottom: '1px solid lightgray',
                  }}
                >
                  <span
                    id="DeviceConnectedTo"
                    style={{
                      overflowWrap: 'break-word',
                      width: '140px',
                      whiteSpace: 'pre',
                    }}
                  >
                    {this.getConnectedTo(element)}
                  </span>
                </td>
                <td
                  id="DeviceConnection"
                  style={{
                    padding: '12px',
                    borderRight: 'none',
                    borderLeft: 'none',
                    borderBottom: '1px solid lightgray',
                  }}
                >
                  {freq}
                  {element.channel ? '/' + element.channel : ''}
                </td>
                <td
                 id = 'DeviceModel'
                  style={{
                    padding: '12px',
                    borderRight: 'none',
                    borderLeft: 'none',
                    borderBottom: '1px solid lightgray',
                  }}
                >
                  <span
                    style={{
                      wordWrap: 'normal',
                      display: 'block',
                      width: '160px',
                      whiteSpace: 'normal',
                    }}
                  >
                    {getDeviceModel(element.mac, 'shortName', this.props.advancedDeviceIds)}
                  </span>
                </td>
                {!sessionStorage.getItem('type')?.includes('Business') && GroupName}
                <td
                  id="Paused"
                  style={{
                    padding: '12px',
                    textAlign: 'center',
                    borderRight: 'none',
                    borderLeft: 'none',
                    borderBottom: '1px solid lightgray',
                  }}
                >
                  {paused}
                </td>
                {speedBoostName}
              </tr>
            </Box>
          );
        });
      }else{
        return (
          <td  colSpan="6" style={{ color: 'gray', textAlign: 'center', height:'20vh'}}>
            There are no Devices Information available with your preferred filters
          </td>
      );
      }
  }

  sortField = (field) => {
    if(this.state.sortBy === field){
      return this.state.sortDirection === "desc"
      ?  <FaSortUp fontSize={'18px'} />
      :  <FaSortDown fontSize={'18px'} />
    } else {
      return '';
    }
  }
  groupColumn = () => {
    return !this.props.enableGroupPause && sessionStorage.getItem('type')?.includes('Business')
            ? ''
            : (
              <th
                style={{ color: 'gray', width: '15%', cursor: 'pointer' }}
                className={classes.devicesThTag}
                onClick={() => {
                  this.sortTable('deviceGroupName', 'column');
                }}
              >
                Group
                {this.sortField('deviceGroupName')}
              </th>
              )
    }

  speedBoostColumn = () => {
    return sessionStorage.getItem('featureFlags').includes('speedBoost') && this.props?.speedBoostDevices?.eligible && !this.props.hideSpeedBoostColumn
            ? (
                <th
                  style={{ width: '9%', cursor: 'pointer' }}
                  className={classes.devicesPauseThTag}
                  onClick={() => {
                    this.sortTable('boost', 'column');
                  }}
                >
                  Boost
                  {this.sortField('boost')}
                </th>
              )
            : null;
      }


  prepareTableHeaders = () => {
  
  // console.log('this.state.filterOptions.connectionStatus', this.state.filterOptions)
    return (
      <tr>
          <th
            className={classes.showDesktop}
            style={{
              color: 'gray',
              width: '95%',
              borderLeft: 'none',
              borderRight: 'none',
              textAlign: 'left',
              padding: '28px',
              borderBottom: '1px solid lightgray',
              cursor: 'pointer',
            }}
            onClick={() => {
              this.sortTable('deviceName', 'column');
            }}
          >
            Device Name
            {this.sortField('deviceName')}
          </th>

          <th
            style={{ width: '12%', cursor: 'pointer' }}
            className={classes.devicesThTag}
            onClick={() => {
              this.sortTable('deviceSignalStatus', 'column');
            }}
          >
            Signal
            {this.sortField('deviceSignalStatus')}
          </th>
          <th
            style={{ width: '16%', cursor: 'pointer' }}
            className={classes.devicesThTag}
            onClick={() => {
              this.sortTable('deviceConnectedTo', 'column');
            }}
          >
            Connected To
            {this.sortField('deviceConnectedTo')}
          </th>
          <th
            style={{ width: '13%', cursor: 'pointer' }}
            className={classes.devicesThTag}
            // onClick={() => {
            //   this.sortTable('freq', 'column');
            // }}
          >
            Connection
            {/* {this.sortField('freq')} */}
             <div>
                <SelectDropdown
                  height={'30px'}
                  width={'150px'}
                  name="deviceConnection"
                  placeholder='All'
                  value={connectionStatusFilters.filter(option => option.value.includes(this.state.filterOptions.deviceConnection))}
                  options={connectionStatusFilters.filter(option => option)}
                  isSearchable={false}
                  onChange={(e) => {
                    // console.log(e)
                    this.filterDeviceData(e, "deviceConnection")}
                  }
                />
              </div>
          </th>
          <th
            style={{
              color: 'gray',
              width: '20%',
              cursor: 'pointer',
            }}
            className={classes.devicesThTag}
            onClick={() => {
              this.sortTable('deviceModel', 'column');
            }}
          >
            Device Model
            {this.sortField('deviceModel')}
          </th>
          {!sessionStorage.getItem('type')?.includes('Business') && this.groupColumn()}
          <th
            style={{ width: '9%', cursor: 'pointer' }}
            className={classes.devicesPauseThTag}
            onClick={() => {
              this.sortTable('paused', 'column');
            }}
          >
            Pause
            { this.sortField('paused')}
          </th>
          {this.speedBoostColumn()}
        </tr>
    )
  }

  updateDeletedDevice(mac) {
    this.setState({deletedDeviceMac: mac})
  }

  render() {
    let featureFlags = sessionStorage.getItem('featureFlags');

    let arrowM = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    if (this.state.upArrows) { arrowM = <MdKeyboardArrowUp aria-label="arrow up" color={'gray'} size={'30px'} /> }
    if (this.props.loading || this.props.deviceGroupsLoading || !this.props.loaded || this.state.deviceReset || this.props.enableDeviceSteeringLoading || (this.props.wan && this.props.wan.checkingWan) || (this.props.wan && this.props.wan.podTimer && this.props.wan.rebootPodId)) {
      return (
        <div className={classes.HeaderArea}>
          <Spinner />
        </div>
      );
    } else if (this.props.errorStatus || (!this.props.devicesByEquipment && !this.props.deviceDisplayMsg)) {
      return null;
    } else if (!this.props.devicesByEquipment) {
      if (this.props.deviceDisplayMsg) {
        return (
          <div className={[classes.DeviceList].join(' ')}>
            <div style={{ padding: '20px', alignItems: '' }}>
              <div className={classes.TitleLeft}>
                <h3 id="DeviceList" style={{ paddingRight: '20px' }}>
                  Device List
                </h3>
              </div>
            </div>
            <div style={{ border: '1px solid #ccc' }} />
            <div className={classes.HeaderArea}>
              <div id="nodeviceavailable" style={{ color: 'gray', textAlign: 'center', padding: '15px' }}>
                {this.props.deviceDisplayMsg}

              </div>
            </div>
          </div>
        );
      }
      return (
        <div className={classes.HeaderArea}>
          <div id="Nodevicesavailable" style={{ color: 'gray' }}>
            There is no Device Information available at this time
          </div>
        </div>
      );
    } else if ((this.state.currentRecords && this.state.currentRecords.length) || (this.props.devicesByEquipment && this.state.filterOptions !== '' && this.state.currentRecords.length === 0)) {

      const { currentPage, itemsPerPage } = this.state;
      const indexOfLast = currentPage * itemsPerPage;
      const indexOfFirst = indexOfLast - itemsPerPage;
      let deviceGroups = getGroupMap(this.props.deviceGroups);
      let showDevIPModal;

      if (this.state.showDeets && this.state.adding) {
        let {deviceName} = getDeviceName(this.state.showDeets, this.props.advancedDeviceIds);
        let advancedDeviceIdsType = 'Default';

        let bandwidthM;
        if (
          this.props.devicesByEquipment &&
          this.props.devicesByEquipment.length &&
          this.props.bandwidth &&
          this.props.bandwidth.device
        ) {
          bandwidthM = this.props.bandwidth.device.find(
            (dev) => dev.deviceMAC === this.state.showDeets.mac
          );
        } else {
          bandwidthM = null;
        }

        if (this.props.advancedDeviceIds && this.props.advancedDeviceIds[this.state.showDeets.mac] && this.props.advancedDeviceIds[this.state.showDeets.mac]['advancedDeviceId']) {
          advancedDeviceIdsType = this.props.advancedDeviceIds[this.state.showDeets.mac]['advancedDeviceId'].type;
        }

        let originalDevice = this.state.showDeets ? this.state.showDeets : null;
        let deviceGroupName = getGroupName(deviceGroups, originalDevice.mac);
        let groupFreezeTemplate = originalDevice.freeze || false;

        if (!deviceGroupName) {
          deviceGroupName = 'Ungrouped';
        } else {
          originalDevice.freeze = groupFreezeTemplate;
        }

        let status;

        if (this.state.showDeets && this.state.showDeets.connectionState &&
          this.state.showDeets.connectionState === 'connected' &&
          this.state.showDeets.freeze.frozen === true
        ) {
          status = 'Paused';
        } else if (this.state.showDeets && this.state.showDeets.health && this.state.showDeets.health.status) {
          status =
            this.state.showDeets.health.status.charAt(0).toUpperCase() +
            this.state.showDeets.health.status.slice(1);
        } else {
          status = 'Disconnected';
        }
       
        showDevIPModal = (
          <div>
            <DeviceDetails
              originalDevice={originalDevice}
              devName={deviceName}
              signalStatus={status}
              bandwidth={bandwidthM}
              isLoading={this.props.loading}
              resetUpArrows={this.resetUpArrows}
              deviceIconUrl={this.state.deviceIconUrl}
              deviceModel={this.state.deviceModel}
              softwareVersion={this.state.softwareVersion}
              deviceGroupName={deviceGroupName}
              groupFreezeTemplate={groupFreezeTemplate}
              updateScheduleDetails={this.updateScheduleDetails}
              advancedDeviceIdsType={advancedDeviceIdsType}
              selectedEquipment={this.props.selectedEquipment}
              updateDeletedDevice={this.updateDeletedDevice}
              devicesByEquipment={this.props.devicesByEquipment}
            />
          </div>
        );
      }
      if ((this.props.error || this.props.deviceSteeringFailed) && !this.state.error) {
        this.setState({ error: true });
        if (this.props.deviceSteeringFailed) {
          this.props.onResetDevicesSteeringErrorSuccess();
        }

        let colorDot, paused;
        let freq;
        let status;
        const boostedDevices =
          this.props.speedBoostDevices &&
            Object.keys(this.props.speedBoostDevices).length
            ? this.props.speedBoostDevices.devices
            : [];
         const findBoostData = boostedDevices.filter(ele => { 
          const macFilter = this.state.showDeets.mac.replaceAll(':', '');
          return ele.clientMac === macFilter;
        }); 
        const boostStatus = findBoostData ? findBoostData[0]?.boostStatus : 'Disconnected';
        let boostElement;
        switch (boostStatus) {
          case 'CAPABLE':
            boostElement = (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <FaTachometerAlt color="#0073D1" height="24px" />
                <span>CAPABLE</span>
              </div>

            );
            break;
          case 'NOT_CAPABLE':
            boostElement = (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <FaTachometerAlt color="grey" height="24px" />
                <span style={{ whiteSpace: 'nowrap' }}>NOT CAPABLE</span>
              </div>
            );
            break;
          case 'BOOSTED':
            boostElement = (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <FaTachometerAlt color="#0073D1" height="24px" />
                <span>Boosted</span>
              </div>
            );
            break;
          case 'NOT_BOOSTED':
            boostElement = (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <FaTachometerAlt color="#CC911E" height="24px" />
                <span style={{ whiteSpace: 'nowrap' }}>Not Boosted</span>
              </div>
            );
            break;
          default:
            boostElement = <span> N/A </span>;
        }

       
      }
      if ((this.props.success || this.props.deviceSteeringSuccess) && !this.state.success) {
        this.setState({ success: true });
        if (this.props.deviceSteeringSuccess) {
          this.props.onResetDevicesSteeringErrorSuccess();
          this.props.resetSteeringPolling();
        }
        if (this.props.success) {
          this.props.onResetDevicesErrorSuccess();
        }
        this.props.onSetSelectedEquipment(this.props.selectedEquipment);
      }
      let deviceList = this.prepareDataForTable(this.state.currentRecords, deviceGroups, featureFlags);
      let signalData = this.state.currentRecords.map((element, ind) => {
        let {shortDeviceName} = getDeviceName(element, this.props.advancedDeviceIds);
        let deviceIconUrl = getDeviceIconUrl(element.mac, this.props.advancedDeviceIds);
        return (
          <Box key={ind}>
            <tr>
              <td
                className={[
                  classes.showMobile,
                  classes.showMobile1,
                  classes.deviceNameIcon,
                ].join(' ')}
              >
                <DeviceIcon size={30} iconUrl={deviceIconUrl} />
                <span
                  style={{
                    marginLeft: '0px',
                    wordWrap: 'break-word',
                    whiteSpace: 'normal',
                    cursor: 'pointer',
                  }}
                  className={[classes.devName, classes.RegularButton].join(
                    ' '
                  )}
                  onClick={() =>
                    this.showDeviceDetails(
                      element,
                      deviceIconUrl
                    )
                  }
                >
                  {shortDeviceName}
                </span>
              </td>
            </tr>
          </Box>
        );
      });

      if (this.props.displayPoorAndDisConnectedDevices) {
        return (
          <Box>
            <div className={[classes.DeviceList].join(' ')}>
              <div
                className={[
                  classes.NetworkDeviceListComponent,
                  classes.showDesktop,
                ].join(' ')}
              >
                <Collapsible
                  open={true}
                  transitionTime={100}
                  onOpening={() => {
                    this.openHandler();
                  }}
                  onClosing={() => {
                    this.closeHandler();
                  }}
                  trigger={
                    <Box>
                      <div
                        className={classes.NetworkDeviceListComponentCollapse}
                      >
                        <div className={classes.NetworkDeviceListTitleArea}>
                          <h3 style={{ paddingRight: 20 }}>
                            Device Performance
                          </h3>

                          <button
                            className={classes.OpenCloseButton}
                            style={{ float: 'right' }}
                            aria-label="open arrow"
                          >
                            {arrowM}
                          </button>
                        </div>

                        <div className={classes.HorizontalSeparator} />
                      </div>
                    </Box>
                  }
                >
                  <table
                    className={classes.devTable}
                    cellPadding="0"
                    cellSpacing="0"
                  >
                    <thead>
                      {this.prepareTableHeaders()}
                    </thead>
                    <tbody>{deviceList}</tbody>
                  </table>
                </Collapsible>
              </div>
              <div className={classes.showMobile}>
                <Collapsible
                  open={true}
                  transitionTime={100}
                  onOpening={() => {
                    this.openHandler();
                  }}
                  onClosing={() => {
                    this.closeHandler();
                  }}
                  trigger={
                    <Box>
                      <div
                        className={[
                          classes.showMobile1,
                          classes.TitleArea,
                        ].join(' ')}
                      >
                        <div className={classes.TitleLeft}>
                          <h3>Device Performance</h3>
                        </div>
                        <button
                          id="deviceopenarrow"
                          className={classes.OpenCloseButton}
                          style={{ float: 'right' }}
                          aria-label="open arrow"
                        >
                          {arrowM}
                        </button>
                      </div>
                    </Box>
                  }
                >
                  <div className={classes.showMobile} style={{ float: 'left', width: '160px' }}>
                    <table className={classes.devTable} cellPadding="0" cellSpacing="0">
                      <thead>
                        <tr>
                          <th
                            style={{
                              color: 'gray',
                              borderLeft: 'none',
                              borderRight: 'none',
                              textAlign: 'left',
                              padding: '10px',
                              borderBottom: '1px solid lightgray',
                            }}
                            onClick={() => {
                              this.sortTable('deviceName');
                            }}
                          >
                            Device Name
                            {this.sortField('deviceName')}{' '}
                          </th>
                        </tr>
                      </thead>
                      <tbody>{signalData}</tbody>
                    </table>
                  </div>

                  <div className={classes.tablewrapper}>
                    <table
                      className={classes.devTable}
                      cellPadding="0"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th
                            className={classes.devicesThTag}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              this.sortTable('deviceSignalStatus');
                            }}
                          >
                            Signal
                            {this.sortField('deviceSignalStatus')}
                          </th>
                          <th
                            className={classes.devicesThTag}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              this.sortTable('deviceConnectedTo');
                            }}
                          >
                            Connected To
                            {this.sortField('deviceConnectedTo')}
                          </th>
                          <th
                            className={classes.devicesThTag}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              this.sortTable('freq');
                            }}
                          >
                            Connection
                            {this.sortField('freq')}
                          </th>
                          <th
                            className={classes.devicesThTag}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              this.sortTable('deviceModel');
                            }}
                          >
                            Device Model
                            {this.sortField('deviceModel')}
                          </th>
                          {!sessionStorage.getItem('type')?.includes('Business') && this.groupColumn()}
                          <th
                            className={classes.devicesPauseThTag}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              this.sortTable('paused');
                            }}
                          >
                            Pause
                            {this.sortField('paused')}
                          </th>
                          {this.speedBoostColumn()}
                        </tr>
                      </thead>
                      <tbody>{deviceList}</tbody>
                    </table>
                  </div>
                </Collapsible>
              </div>
            </div>

            <SlidePanel
              devDeets="true"
              show={this.state.adding}
              modalClosed={this.modalCancelHandler}
            >
              <button
                id="BackToWifiServiceCheck"
                className={[
                  classes.RegularButton,
                  classes.RegularButtonWifiService,
                ].join(' ')}
                style={{ marginTop: '2px' }}
                onClick={this.modalCancelHandler}
              >
                {'<'} Back To Wifi Service Check
              </button>
              {showDevIPModal}
              <Modal
                show={this.state.error}
                modalClosed={this.successErrorResetHandler}
              >
                <Error id={'DeviceDetailsError'} />
              </Modal>
              <Modal
                show={this.state.success}
                modalClosed={this.successErrorResetHandler}
              >
                <Success id={'DeviceDetailsSuccess'} />
              </Modal>
            </SlidePanel>
          </Box>
        );
      }

      return (
        <Box>
          {!this.state.adding &&
             <div className={[classes.DeviceList].join(' ')}>
             <div className={classes.showDesktop}>
               <div style={{ padding: '20px', alignItems: '' }}>
                 <div className={classes.TitleLeft}>
                   <h3 id="DeviceList" style={{ paddingRight: '20px' }}>
                     Device List
                   </h3>
                 </div>
               </div>

               <Collapsible
                 open={true}
                 transitionTime={100}
                 onOpening={() => {
                   this.openHandler();
                 }}
                 onClosing={() => {
                   this.closeHandler();
                 }}
                 trigger={
                   <Box>
                     <div
                       className={[classes.showMobile1, classes.TitleArea].join(
                         ' '
                       )}
                     >
                       <div className={classes.TitleLeft}>
                         <h3>Device List</h3>
                       </div>
                       <button
                         id="deviceopenarrow"
                         className={classes.OpenCloseButton}
                         style={{ float: 'right' }}
                         aria-label="open arrow"
                       >
                         {arrowM}
                       </button>
                     </div>
                   </Box>
                 }
               >
                 <div className={classes.tablewrapper} style={{ overflowX: 'auto', minHeight:'35vh' }}>
                   <table
                     className={classes.devTable}
                     cellPadding="0"
                     cellSpacing="0"
                   >
                     <thead>
                     {this.prepareTableHeaders()}
                     </thead>
                     <tbody>{deviceList}</tbody>
                   </table>
                 </div>
               </Collapsible>
             </div>
             <div className={classes.showMobile}>
               <Collapsible
                 open={true}
                 transitionTime={100}
                 onOpening={() => {
                   this.openHandler();
                 }}
                 onClosing={() => {
                   this.closeHandler();
                 }}
                 trigger={
                   <Box>
                     <div
                       className={[classes.showMobile1, classes.TitleArea].join(
                         ' '
                       )}
                     >
                       <div className={classes.TitleLeft}>
                         <h3>Device List</h3>
                       </div>
                       <button
                         id="deviceopenarrow"
                         className={classes.OpenCloseButton}
                         style={{ float: 'right' }}
                         aria-label="open arrow"
                       >
                         {arrowM}
                       </button>
                     </div>
                   </Box>
                 }
               >
                 <div className={classes.showMobile} style={{ float: 'left' }}>
                   <table cellPadding="0" cellSpacing="0">
                     <thead>
                       <tr>
                         <th
                           style={{
                             color: 'gray',
                             borderLeft: 'none',
                             borderRight: 'none',
                             textAlign: 'left',
                             padding: '10px',
                             borderBottom: '1px solid lightgray',
                           }}
                           onClick={() => {
                             this.sortTable('deviceName');
                           }}
                         >
                           Device Name
                           {this.sortField('deviceName')}{' '}
                         </th>
                       </tr>
                     </thead>
                     <tbody>{signalData}</tbody>
                   </table>
                 </div>

                 <div className={classes.tablewrapper} style={{ overflowX: 'auto', minHeight: '40vh' }}>
                   <table
                     className={classes.devTable}
                     cellPadding="0"
                     cellSpacing="0"
                   >
                     <thead>
                       <tr>
                         <th
                           className={classes.devicesThTag}
                           style={{ cursor: 'pointer' }}
                           onClick={() => {
                             this.sortTable('deviceSignalStatus');
                           }}
                         >
                           Signal
                           {this.sortField('deviceSignalStatus')}
                         </th>
                         <th
                           className={classes.devicesThTag}
                           style={{ cursor: 'pointer' }}
                           onClick={() => {
                             this.sortTable('deviceConnectedTo');
                           }}
                         >
                           Connected To
                           {this.sortField('deviceConnectedTo')}
                         </th>
                         <th
                           className={classes.devicesThTag}
                          //  style={{ cursor: 'pointer' }}
                          //  onClick={() => {
                          //    this.sortTable('freq');
                          //  }}
                         >
                           Connection
                           {/* {this.sortField('freq')} */}
                             <div>
                                <SelectDropdown
                                  height={'30px'}
                                  customWidth='100px'
                                  name="deviceConnection"
                                  placeholder='All'
                                  value={connectionStatusFilters.filter(option => option.value.includes(this.state.filterOptions.deviceConnection))}
                                  options={connectionStatusFilters.filter(option => option)}
                                  isSearchable={false}
                                  onChange={(e) => {
                                    // console.log(e)
                                  this.filterDeviceData(e, "deviceConnection")}
                              }
                           />
                            </div>
                         </th>
                         <th
                           className={classes.devicesThTag}
                           style={{ cursor: 'pointer' }}
                           onClick={() => {
                             this.sortTable('deviceModel');
                           }}
                         >
                           Device Model
                           {this.sortField('deviceModel')}
                         </th>
                         {!sessionStorage.getItem('type')?.includes('Business') && this.groupColumn()}
                         <th
                           className={classes.devicesThTag}
                           style={{ cursor: 'pointer' }}
                           onClick={() => {
                             this.sortTable('paused');
                           }}
                         >
                           Pause
                           {this.sortField('paused')}
                         </th>
                         {this.speedBoostColumn()}
                         {/* {qoeScoreColumn} */}
                       </tr>
                     </thead>
                     <tbody>{deviceList}</tbody>
                   </table>
                 </div>
               </Collapsible>
             </div>
           </div>
          }

          {this.state.deletedDeviceMac !== null &&
          <>
            <Modal
              show={this.state.error}
              modalClosed={this.successErrorResetHandler}
            >
              <Error id={'DeviceDetailsDeletedError'} />
            </Modal>
            <Modal
              show={this.state.success}
              modalClosed={this.successErrorResetHandler}
            >
              <Success id={'DeviceDetailsDeletedSuccess'} />
            </Modal>
            </>
          }
          {/* {!this.state.success ? */}
          <SlidePanel
            devDeets="true"
            show={this.state.adding}
            modalClosed={this.modalCancelHandler}
          >
            <button
              id='BackDevicesList'
              className={classes.RegularButton}
              style={{ marginTop: '2px' }}
              onClick={this.modalCancelHandler}
            >
              {'<'} Back To Devices List
            </button>
            {showDevIPModal}
            {this.state.deletedDeviceMac === null &&
            <>
              <Modal
                show={this.state.error}
                modalClosed={this.successErrorResetHandler}
              >
                <Error id={'DeviceDetailsError'} />
              </Modal>
              <Modal
                show={this.state.success}
                modalClosed={this.successErrorResetHandler}
              >
                <Success id={'DeviceDetailsSuccess'} />
              </Modal>
            </>}
          </SlidePanel>
        </Box>
      );
    } else {
      if (this.props.deviceDisplayMsg) {
        return (
          <div className={[classes.DeviceList].join(' ')}>
            <div style={{ padding: '20px', alignItems: '' }}>
              <div className={classes.TitleLeft}>
                <h3 id="DeviceList" style={{ paddingRight: '20px' }}>
                  Device Performance
                </h3>
              </div>
            </div>
            <div style={{ border: '1px solid #ccc' }} />
            <div className={classes.HeaderArea}>
              <div id="nodeviceavailable" style={{ color: 'gray', textAlign: 'center', padding: '15px' }}>
                {this.props.deviceDisplayMsg}
              </div>
            </div>
          </div>
        );
      }

      return (
        <div className={classes.HeaderArea}>
          <div id="nodeviceavailable" style={{ color: 'gray' }}>
            There is no Device Information available at this time

          </div>
        </div>
      );
    }
  }
}


const mapStateToProps = (state) => {
  return {
    secondSsid: state.secondSsid,
    bandwidth: state.bandwidth.realBandwidth,
    loading: state.devices.loading,
    loaded: state.devices.loaded,
    account: state.settings.account,
    isAuthenticated: state.auth.token !== null,
    isPinxt: state.auth.pToken !== null,
    realSettings: state.settings.realSettings,
    isDummy: state.auth.isDummy,
    success: state.devices.success,
    error: state.devices.error,
    errorStatus: state.devices.errorStatus,
    claimedPods: state.equipment.realEquipment
      ? state.equipment.realEquipment.claimedPods
      : [],
    realWan: state.wan.realWan,
    wan: state.wan,
    selectedEquipment: state.equipment.selectedEquipment,
    advancedDeviceIds: state.devices.advancedDeviceIds,
    deviceGroups: state.deviceGroups.deviceGroups,
    deviceGroupsLoading: state.deviceGroups.loading,
    deviceGroupsLoaded: state.deviceGroups.loaded,
    speedBoostDevices: state.speedBoost.speedBoostDevices,
    enableDeviceSteeringLoading: state.deviceSteering.enableAndDisableDeviceSteeringLoading,
    deviceSteeringSuccess: state.deviceSteering.enableAndDisableDeviceSteeringSuccess,
    deviceSteeringFailed: state.deviceSteering.enableAndDisableDeviceSteeringFailed,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetAdvancedDevice: (deviceMac, days) => {
      dispatch(actions.getAdvancedDevice(deviceMac, days));
    },
    onGetAdvancedDeviceIds: (deviceMacs) => {
      dispatch(actions.getAdvancedDeviceIds(deviceMacs));
    },
    onResetDevicesErrorSuccess: () => {
      dispatch(actions.resetDevicesErrorSuccess());
    },
    onResetDevicesSteeringErrorSuccess: () => {
      dispatch(actions.resetDevicesSteeringErrorSuccess());
    },
    onSetSelectedEquipment: (equipment) => {
      dispatch(actions.setSelectedEquipment(equipment));
    },
    resetSteeringPolling: () => {
      dispatch(actions.endSteeringPolling());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(DeviceList, api));



